/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';

// MATERIAL UI IMPORT
import { Box, Stack, Menu, MenuItem, IconButton } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import closeFill from '@iconify/icons-eva/close-fill';
import { Icon } from '@iconify/react';
// OTHER IMPORTS
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import ReactToPrint from 'react-to-print';
import { exportComponentAsJPEG, exportComponentAsPDF, exportComponentAsPNG } from 'react-component-export-image';
import { CollapseDrawerContext } from '../../../../../contexts/CollapseDrawerContext';
import { ReactBarChart } from '../../../../Common Component/ReactChart';

// CONTEXT IMPORTS
QuestionByStaffGraph.propTypes = {
  perGraphData: PropTypes.array,
  graphQuestionArray: PropTypes.array,
  graphQuestionIdArray: PropTypes.array,
  handleRedirect: PropTypes.func,
  hght: PropTypes.number,
  wdth: PropTypes.number,
};

export default function QuestionByStaffGraph({ perGraphData, graphQuestionArray, graphQuestionIdArray, handleRedirect, wdth, hght }) {
  // STATES

  const handle = useFullScreenHandle();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const theme = useTheme();
  const BAR_GRAPH_COLOR = theme.palette.graphColors.graphColor;

  const { collapseClick } = React.useContext(CollapseDrawerContext);

  const componentRef = React.useRef();
  const componentRef1 = React.useRef();

  // RESIZE STATES
  const [graphWidth, setGraphWidth] = React.useState(0);
  const [graphHeight, setGraphHeight] = React.useState(450);

  React.useEffect(() => {
    if (handleRedirect) {
      let x = 0;
      if (collapseClick) {
        x = 150;
      } else {
        x = 80;
      }

      if (componentRef.current) {
        setGraphWidth(componentRef.current.offsetWidth - x);
      } else {
        setGraphWidth(0);
      }
    }
    if (!handleRedirect) {
      setGraphWidth(wdth);
      setGraphHeight(hght);
    }
  }, [componentRef, collapseClick, hght, wdth]);

  const handleChartEvents = (event, chartContext, config) => {
    const tempIndex = config.w.config.xaxis.categories[config.dataPointIndex] - 1;
    const tempQuestionId = graphQuestionIdArray[tempIndex];
    if (handleRedirect) {
      handleRedirect(tempQuestionId);
    }
  }

  const handleTooltipCustomFun = (series, seriesIndex, dataPointIndex, w) => {
    // Get data, name, color, and category
    const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
    const seriesName = w.globals.initialSeries[seriesIndex].name;
    const color = w.globals.colors[seriesIndex];
    const questionNumber = w.globals.labels[dataPointIndex];
    // Return the custom HTML matching the default look
    return `<div style="
        min-width: 150px; 
        font-family: Helvetica, Arial, sans-serif; 
        border: 1px solid #e0e0e0; 
        border-radius: 4px;
        overflow: hidden;
      ">
        <div style="
          background-color: #f3f4f5; 
          padding: 8px 10px; 
          border-bottom: 1px solid #e0e0e0; 
          font-weight: 500;
        ">
         Q${w.globals.labels[dataPointIndex]}: ${questionNumber}
        </div>
        
        <div style="padding: 8px 10px; display: flex; align-items: center;">
          <span style="
            width: 10px; 
            height: 10px; 
            background-color: ${color}; 
            margin-right: 8px; 
            border-radius: 50%;
            display: inline-block;
          "></span>
          <span>Score: <b>${data}%</b></span>
        </div>
      </div>`
  }

  const xAxisLabelFormatter = (val) => {
    return `Q ${val}`;
  }
  return (
    <>
      <Box sx={{ width: '100%', cursor: 'default' }}>
        <FullScreen handle={handle}>
          <Box
            className="my-component"
            display={handle?.active ? 'flex' : 'block'}
            ref={componentRef}
            justifyContent="center"
            alignItems="center"
            sx={{
              position: 'relative',
              width: '100%',
              height: handleRedirect ? '500px' : (hght + Number(50)),
              borderRadius: 1
            }}
          >
            {(handle?.active === false && handleRedirect) && (
              <Box sx={{ position: 'absolute', top: '0', zIndex: 1 }}>
                <Stack direction="row" alignItems="center">
                  <IconButton onClick={handleClick} className="icon">
                    <MenuIcon />
                  </IconButton>
                </Stack>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button'
                  }}
                >
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    onClick={(event) => {
                      handleClose(event);
                      handle.enter();
                    }}
                  >
                    Fullscreen
                  </MenuItem>
                  <ReactToPrint
                    trigger={() => <MenuItem sx={{ fontSize: '12px' }}>Print</MenuItem>}
                    content={() => componentRef1.current}
                  />
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    onClick={(event) => {
                      handleClose(event);
                      exportComponentAsJPEG(componentRef, { fileName: '1.2 Question By Staff.jpeg' });
                    }}
                  >
                    Download Jpeg
                  </MenuItem>
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    onClick={(event) => {
                      handleClose(event);
                      exportComponentAsPNG(componentRef, { fileName: '1.2 Question By Staff.png' });
                    }}
                  >
                    Download png
                  </MenuItem>
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    onClick={(event) => {
                      handleClose(event);
                      exportComponentAsPDF(componentRef1, {
                        fileName: '1.2 Question By Staff.pdf',
                        pdfOptions: { w: 450, h: 300, x: 50, y: 0, unit: 'px' }
                      });
                    }}
                  >
                    Download pdf
                  </MenuItem>
                </Menu>
              </Box>
            )}

            <Box
              sx={{
                my: 2,
                p: 1,
                '@media print': {
                  marginTop: '40px',
                  marginRight: '10px',
                  width: '100%',
                  display: 'block',
                  overflow: 'hidden',
                  position: 'relative'
                }
              }}
            >
              {/* showing button when chart in fullscreen */}
              {
                handle?.active === !false &&
                <Stack display='flex' justifyContent='center' alignItems='center'>
                  <IconButton color="inherit" onClick={handle.exit} sx={{ width: '44px' }}>
                    <Icon icon={closeFill} />
                  </IconButton>
                </Stack>
              }
              <ReactBarChart
                refrence={componentRef1}
                series={perGraphData}
                width={handle?.active ? window?.screen.width : graphWidth}
                height={handle?.active ? window?.screen.height - 250 : graphHeight}
                id='Staf'
                chartEvents={handleChartEvents}
                title=''
                xTitle=''
                yTitle='Percentage'
                legendShow={false}
                xCategories={graphQuestionArray}
                tickAmount={graphQuestionArray?.length > 30 ? 35 : undefined}
                color={undefined}
                plotOptionsDistributed={false}
                handleTooltipCustomFun={handleTooltipCustomFun}
                plotOptionsHorizontal={false}
                xAxisLabelShow={!false}
                xAxisLabelFormatter={xAxisLabelFormatter}
                gridPadding={{ // adjust the column padding from left/right in x-Axis
                  left: 20,
                  right: 60
                }}
              />
            </Box>
          </Box>
        </FullScreen>
      </Box>
    </>
  );
}
